import { definePreset } from '@primevue/themes'
import lara from '@primevue/themes/lara'

import {
  accordion,
  button,
  datatable,
  datepicker,
  dialog,
  divider,
  fieldset,
  message,
  paginator,
  progressbar,
  radiobutton,
  select,
  splitbutton,
  stepper,
  tabs,
  tag,
  toast,
} from './component-presets'

const themeOverrides = {
  semantic: {
    primary: {
      50: '#d8cff7',
      100: '#c3b3fa',
      200: '#ad96fc',
      300: '#9779ff',
      400: '#9779ff',
      500: '#775ebe',
      600: '#66519e',
      700: '#56437d',
      800: '#433461',
      900: '#302646',
      950: '#1d172a',
    },
    warn: {
      50: '#f5ddcd',
      100: '#f7ccaf',
      200: '#f8ba91',
      300: '#f9a872',
      400: '#fb9754',
      500: '#fc8535',
      600: '#e5762a',
      700: '#cd6720',
      800: '#b65915',
      900: '#9e4a0b',
      950: '#873b00',
    },
    'border-radius': {
      none: '0px',
      xs: '4px',
      sm: '6px',
      md: '8px',
      lg: '10px',
      xl: '14px',
    },
    colorScheme: {
      dark: {
        surface: {
          0: '#ffffff',
          50: '#f6f5f8',
          100: '#eceaf0',
          200: '#d2cfdc',
          300: '#b8b4c8',
          400: '#837b96',
          500: '#4e4562',
          600: '#3f3b52',
          700: '#302f41',
          800: '#212330',
          900: '#14141d',
          950: '#09090b',
        },
      },
    },
  },
  components: {
    accordion,
    button,
    datepicker,
    dialog,
    divider,
    fieldset,
    progressbar,
    radiobutton,
    stepper,
    tabs,
    tag,
    message,
    toast,
    select,
    datatable,
    paginator,
    splitbutton,
  },
}

export const ContigoMarketPlacePreset = definePreset(lara, themeOverrides)
